import { useState } from "react";
import { ORGAN_PRESENTATION } from "@/lib/organPresentation";

export function OrganQuote({organId}) {
 const organ=ORGAN_PRESENTATION[organId];
 return organ?.quote ? <blockquote className="dad-organ-quote">{organ.quote}</blockquote> : null;
}
export default function OrganAnatomyVisual({organId,compact=false}) {
 const organ=ORGAN_PRESENTATION[organId];
 const [failedAsset,setFailedAsset]=useState(null);
 if(!organ) return null;
 return <div className={"dad-anatomy-visual"+(compact?" dad-anatomy-visual-compact":"")} data-testid={"anatomy-visual-"+organId}
 style={{"--organ-accent":organ.accent,"--anatomy-focus":organ.focal,"--anatomy-scale":organ.scale}}>
  <figure className="dad-anatomy-figure" aria-hidden="true">
   {failedAsset!==organ.asset ? <img src={organ.asset} alt="" width="560" height="560" decoding="async" loading={compact?"lazy":"eager"} onError={()=>setFailedAsset(organ.asset)}/>:<span className="dad-anatomy-fallback">Illustrazione non disponibile</span>}
  </figure><OrganQuote organId={organId}/>
 </div>;
}
